// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";

function Component(T) {
  var heading = BsCssJs$PrezzeeRibbon.style([
        BsCssJs$PrezzeeRibbon.selector("h1, h2, h3, h4, h5, h6", [
              BsCssJs$PrezzeeRibbon.fontWeight("semiBold"),
              BsCssJs$PrezzeeRibbon.color(T.headingColour)
            ]),
        BsCssJs$PrezzeeRibbon.selector("strong", [
              BsCssJs$PrezzeeRibbon.fontWeight("inherit_"),
              BsCssJs$PrezzeeRibbon.color(T.highlightColour)
            ])
      ]);
  var Styles = {
    heading: heading
  };
  var SectionHeading$Component = function (props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return JsxRuntime.jsx("div", {
                children: props.children,
                className: Classnames([
                      heading,
                      className$1
                    ])
              });
  };
  return {
          Styles: Styles,
          make: SectionHeading$Component
        };
}

export {
  Component ,
}
/* classnames Not a pure module */
